import React, { useEffect, useState } from 'react';
import { Row, Col, Container, Form } from 'react-bootstrap';
import coldLeadIcon from './../../../../Assets/icons/coldleadimg.svg';
import hotLeadIcon from './../../../../Assets/icons/hotleadimg.svg';
import warmLeadICon from './../../../../Assets/icons/warmleadimg.svg';
import axiosInstance from '../../../services/api/API';
import { useNavigate } from 'react-router-dom';
import LeadsDashboard from '../BarChartWithCards';
import './index.scss';
import Select from 'react-select';
import { ColdLeadsChart, HotLeadsChart, WarmLeadsChart } from './WarmLeadsChart';
import ROUTES_NAVIGATION from '../../../../routes/routes';
import { color } from 'chart.js/helpers';
import SalesPerformance from '../SalesPerformance';

const TotalCounts = ({ title,subtitle }) => {
  const [leadsourcebase, setLeadSourceBase] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [SalesPerformanceData,setSalesPerformanceData] = useState([])
  const [selectedDealer, setSelectedDealer] = useState(null);
  const [leadCounts, setLeadCounts] = useState({
    totalLeads: 0,
    newLeads: 0,
    followUpLeads: 0,
    closedLeads: 0,
  });
  const [dealerOptions, setDealerOptions] = useState([]);
  const [graphData, setGraphData] = useState({
    Organic: [],
    SocialMedia: [],
    FromAdds: [],
    Other: [],
  });
  const [leadPriorityData, setLeadPriorityData] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear());

  const token = localStorage.getItem("authToken");
  const usertype = localStorage.getItem("UserType")
  const BUSINESSPARTNERID = localStorage.getItem("business_partner_id")

  
  const navigate = useNavigate();

  // Manually generate month options
  const monthOptions = [
    { value: 1, label: 'Jan' },
    { value: 2, label: 'Feb' },
    { value: 3, label: 'Mar' },
    { value: 4, label: 'Apr' },
    { value: 5, label: 'May' },
    { value:6, label: 'Jun' },
    { value: 7, label: 'Jul' },
    { value: 8, label: 'Aug' },
    { value: 9, label: 'Sep' },
    { value: 10, label: 'Oct' },
    { value: 11, label: 'Nov' },
    { value: 12, label: 'Dec' },
  ];

  const yearOptions = [...Array(5).keys()].map((i) => {
    const yearOption = new Date().getFullYear() - i;
    return {
      value: yearOption,
      label: yearOption,
    };
  });
  
  useEffect(() => {
    const currentMonth = new Date().getMonth() + 1;
    setSelectedMonth(monthOptions.find((option) => option.value === currentMonth));
  }, []);

  useEffect(() => {
    
    fetchGraphData();
    fetchDealers();
  }, [year,selectedMonth,selectedDealer]);

  const fetchGraphData = async () => {
  try {
    const business_partner_id = Number(BUSINESSPARTNERID);
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; 

    const response = await axiosInstance.post("/presale/listgraph", {
      business_partner_id,
      year: year || currentYear,
      month: selectedMonth?.value || null,
      dealer_id:selectedDealer?.value
    }, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const fetchedData = response?.data?.data?.leadbargraph;
    const leadsourcebase = response?.data?.data?.leadsourcebase;
    const leadStatusBase = response?.data?.data?.leadstatusbase;
    const leadPriorityBase = response?.data?.data?.leadprioritybase;
    const salesperformancedata = response?.data?.data?.performancegraph;
    console.log("fetchedData",fetchedData);
    
    setSalesPerformanceData(salesperformancedata)
    setLeadSourceBase(leadsourcebase);

    setGraphData({
      Organic: fetchedData?.Organic || [],
      SocialMedia: fetchedData?.SocialMedia || [],
      FromAdds: fetchedData?.FromAdds || [],
      Other: fetchedData?.Other || [],
      month: fetchedData?.months,
    });

    setLeadCounts({
      leadsContacted:leadStatusBase?.contacted,
      taskcompletion:leadStatusBase?.taskcompletion,
      totalLeads: leadStatusBase?.total,
      newLeads: leadStatusBase?.new_leads,
      followUpLeads: leadStatusBase?.followup,
      convertedLeads: leadStatusBase?.convertedlead,
    });

    setLeadPriorityData(leadPriorityBase);
    console.log("leadprioritybase", leadPriorityBase);

  } catch (error) {
    console.error(error, "error");
  }
};

// Call fetchGraphData when the component mounts


  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: '1px solid #7BD755',
      boxShadow: 'none',
      borderRadius: '20px',
      backgroundColor: '#fff',
      color:'#7BD755'
    }),
     dropdownIndicator: (provided) => ({
      ...provided,
      color: 'green',
    }),
    placeholder: (provided) => ({
      ...provided,
       color:'#7BD755'
    }),
    singleValue: (provided) => ({
      ...provided,
       color:'#7BD755'
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '4px',
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#7BD755' : provided.backgroundColor,
      color:state.isFocused ?'#fff':'#000'
    }),
  };

  const fetchDealers = async () => {
    try {
      // Replace with the actual endpoint and payload for fetching dealer options
      const response = await axiosInstance.post("/dealer/ddlDealer", {
        business_partner_id: 1,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const dealers = response?.data?.data?.data || [];
      setDealerOptions(dealers.map(dealer => ({
        value: dealer.ID,
        label: dealer.NAME,
      })));

    } catch (error) {
      console.error(error, "error");
    }
  };
  console.log("leadCounts",leadCounts);

  const handleUploadLead = () => {
    navigate(ROUTES_NAVIGATION.LEADUPLOAD)
  }

  return (
    <>
      <div className="filtercontainer mt-3 mb-3">
        <Form.Group controlId="formDealer" className="filter-dropdown">
          <Select
          isClearable 
            styles={customStyles}
            options={dealerOptions}
            value={selectedDealer}
            onChange={(option) => setSelectedDealer(option)}
            placeholder="Select Dealer"
          />
        </Form.Group>
      </div>

      <Container fluid>
        <Row className='align-items-center'>
          <Col xs={12} className='d-flex flex-wrap justify-content-around' style={{backgroundColor:"#fff"}}>
          <div>
          <p style={{fontSize:12,color:'grey'}}>{subtitle}</p>
             <h5>{title}</h5>
          </div>
       
            <div className='totalvalues text-center word-wrap'>
              <h5 className="totalcount">{leadCounts.totalLeads?leadCounts.totalLeads:0}</h5>
              <span className="totaltitle">Total</span>
              <span className="totaltitle">Leads</span>
            </div>
            <div className='totalvalues text-center word-wrap'>
              <h5 className="totalcount">{leadCounts.followUpLeads?leadCounts.followUpLeads:0}</h5>
              <span className="totaltitle">FollowUp</span>
              <span className="totaltitle">Calls</span>
            </div>
            <div className='totalvalues text-center word-wrap'>
              <h5 className="totalcount">{leadCounts?.convertedLeads ?leadCounts?.convertedLeads:0}</h5>
              <span className="totaltitle">Leads</span>
              <span className="totaltitle">Converted</span>
            </div>
            <div className='totalvalues text-center word-wrap'>
              <h5 className="totalcount">{leadCounts.leadsContacted?leadCounts.leadsContacted:0}</h5>
              <span className="totaltitle">Leads</span>
              <span className="totaltitle">Contacted</span>
            </div>
            <div className='totalvalues text-center word-wrap'>
              <h5 className="totalcount">{leadCounts?.taskcompletion?leadCounts?.taskcompletion:0} %</h5>
              <span className="totaltitle">Task</span>
              <span className="totaltitle">Completion</span>
            </div>
            {/* <div className='totalvalues text-center word-wrap'>
              <h5 className="totalcount">{leadCounts.closedLeads}</h5>
              <span className="totaltitle">Response</span>
              <span className="totaltitle">Time</span>
            </div> */}
           <div>
          <>
          <div className="areachartcontainer"><HotLeadsChart data={leadPriorityData} />
          <ColdLeadsChart data={leadPriorityData} />
          <WarmLeadsChart data={leadPriorityData} /></div>
          
        </>
           </div>
            <div className="filtercontainer">
              <Form.Group controlId="formMonth" className="filter-dropdown">
                <Select
                isClearable
                  styles={customStyles}
                  options={monthOptions}
                  value={selectedMonth}
                  onChange={(option) => setSelectedMonth(option)}
                  placeholder="Select Month"
                />
              </Form.Group>
              <Form.Group controlId="formYear" className="filter-dropdown">
                <Select
                isClearable
                  styles={customStyles}
                  options={yearOptions}
                  value={yearOptions.find(option => option?.value === year)}
                  onChange={(option) => setYear(option?.value)}
                  placeholder="Select Year"
                />
              </Form.Group>
            </div>

            <div className="btn-container">
              <button style={{marginTop:"10px"}} className='submit-btn' onClick={()=>navigate(ROUTES_NAVIGATION.ADDLEAD)} >
                Add Lead
              </button>
              <button onClick={handleUploadLead}className='upload-btn'>
            
                Upload Lead
              </button>
            </div>

          </Col>
        </Row>
      </Container>
      {usertype==="telecaller"? <div>
         <SalesPerformance SalesPerformanceData={SalesPerformanceData} />     
      </div>:
       <div>
        <LeadsDashboard graphData={graphData} leadsourcebase={leadsourcebase} />
      </div>}
     
     
    </>
  );
};

export default TotalCounts;
